import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';

type Props = {
  logQueue: StringKAnyVPair[],
};

const ConsoleWrapper = styled.div`
  height: 100%;
  overflow-y: auto;

  & .log-item {
    align-content: center;
    border-bottom: 1px dotted #D9D9D9;
    min-height: 28px;
    width: 100%;
  }

  & .log-item-separator {
    display: inline-block;
    width: 10px;
  }

  & .log-text {
    background-color: #EEE;
    border: 1px solid #ECECEC;
    border-bottom: none;
    border-radius: 6px;
    border-top: none;
    padding: 2px 4px;
  }
`;

const Console = (props: Props) => {
  const renderLogQueue = (logs: StringKAnyVPair[]) => {
    return logs.map(log => (
      <div className="log-item" key={log.id}>
        {log.logs.length > 0 && (<>
          <Tag color="geekblue">{log.logType}</Tag>
          <span className="log-item-separator" />
          {log.logs.map((e: string, i: number) => (<>
            <span className="log-text" key={`${log.id}-${i}`}>{e}</span>
            {i !== log.logs.length - 1 && <span className="log-item-separator" />}
          </>))}
        </>)}
      </div>
    ));
  };

  return (
    <ConsoleWrapper>
      {renderLogQueue(props.logQueue)}
    </ConsoleWrapper>
  );
};

export default Console;
